// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Category-module--wrapper--i23aT"};